import * as yup from "yup";

export const invoiceCategorySchema = yup.object().shape({
  name: yup.string().required().label("Name"),
});
